import React from 'react';
import { motion } from 'framer-motion';
import { SalesButton } from '../ui/SalesButton';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-[#1a2744] min-h-screen flex items-center overflow-hidden" data-id="element-179">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-180">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23c9a227' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} data-id="element-181" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-182">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-183">
          {/* Left Column - Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-184">
            <div className="flex items-center gap-2 mb-6" data-id="element-185">
              <ShieldCheckIcon className="w-6 h-6 text-[#c9a227]" data-id="element-186" />
              <span className="text-[#c9a227] font-semibold uppercase tracking-wider text-sm" data-id="element-187">
                Guía Fiscal 2026
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-188">
              Deja de <span className="text-[#c9a227]" data-id="element-189">Regalarle Tu Sudor</span>{' '}
              al IRS
            </h1>

            <p className="text-xl sm:text-2xl text-gray-300 mb-4 leading-relaxed" data-id="element-190">
              El manual legal para que el contratista latino pague lo mínimo en
              impuestos.
            </p>

            <p className="text-lg text-gray-400 mb-8" data-id="element-191">
              🛡️ Descubre cómo deducir hasta tu celular, gasolina y renta —{' '}
              <strong className="text-white" data-id="element-192">100% legalmente</strong>.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-193">
              <SalesButton size="large" data-id="element-194">OBTENER MI COPIA POR $6.39</SalesButton>
            </div>

            <div className="flex flex-wrap items-center gap-6 text-sm text-gray-400" data-id="element-195">
              <div className="flex items-center gap-2" data-id="element-196">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-197">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-198" />
                </svg>
                <span data-id="element-199">Descarga Inmediata</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-200">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-201">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-202" />
                </svg>
                <span data-id="element-203">En Español</span>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="relative" data-id="element-204">
            <div className="relative" data-id="element-205">
              {/* Glow effect */}
              <div className="absolute -inset-4 bg-[#c9a227]/20 rounded-3xl blur-2xl" data-id="element-206" />

              <img src="https://cdn.magicpatterns.com/uploads/aDYYEtGHkUDy4q9PnMrW4y/el_escudo_1099.png" alt="El Escudo 1099 - Guía mostrada en laptop, tablet y teléfono" className="relative rounded-2xl shadow-2xl w-full" data-id="element-207" />
            </div>

            {/* Price badge */}
            <motion.div initial={{
            scale: 0,
            rotate: -12
          }} animate={{
            scale: 1,
            rotate: -12
          }} transition={{
            delay: 0.6,
            type: 'spring',
            stiffness: 200
          }} className="absolute -bottom-4 -right-4 sm:bottom-4 sm:right-4 bg-[#c9a227] text-[#1a2744] rounded-full w-24 h-24 sm:w-28 sm:h-28 flex flex-col items-center justify-center shadow-xl" data-id="element-208">
              <span className="text-sm font-semibold" data-id="element-209">SOLO</span>
              <span className="text-3xl sm:text-4xl font-bold" data-id="element-210">$6.39</span>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}